module.exports = __webpack_public_path__ + "img/menu-button-wide-fill.4d457371.svg";